// src/components/Header.js
import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebaseConfig';
import { signOut } from 'firebase/auth';
import './Header.css';

function Header() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <Navbar bg="light" expand="lg" className='mb-5'>
      <Container>
        <Navbar.Brand as={NavLink} to="/">VIDYARTHI-24</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/">Home</Nav.Link>
            {!user && <Nav.Link as={NavLink} to="/login">Login</Nav.Link>}
            {/* {!user && <Nav.Link as={NavLink} to="/signup">Sign Up</Nav.Link>} */}
            {user && <Nav.Link as={NavLink} to="/create">Dashboard</Nav.Link>}
            {user && (
              <Button variant="link" onClick={handleLogout}>Logout</Button>
            )}

              <a target='_blank' href="https://drive.google.com/drive/folders/1s0c52nff5gNDJTIRWp_N58jzH3TA-wnD?usp=sharing" className="pk-ebook-link nav-link fw-bold text-decoration-underline">Get Complete PDF Collection</a>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
